import { render, staticRenderFns } from "./homeProduct.vue?vue&type=template&id=f0a37990&scoped=true"
import script from "./homeProduct.vue?vue&type=script&lang=ts"
export * from "./homeProduct.vue?vue&type=script&lang=ts"
import style0 from "./homeProduct.vue?vue&type=style&index=0&id=f0a37990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a37990",
  null
  
)

export default component.exports